/**
 * The right-hand detail drawer: title, chips and status beneath it, tabs, and footer buttons. The kit's tokens are
 * applied on the drawer itself (it renders in a portal, outside CpvScreen).
 */
import React from 'react';
import { Drawer, Tabs } from 'antd';
import { LAYOUT } from './tokens';
import { useCpvTokens } from './useCpvTokens';
import './cpv-ui.css';

export default function DetailDrawer({ open, onClose, title, chips, status, tabs, activeTab, onTab, footer, children, testId, width = LAYOUT.drawerWidth }) {
  const { vars } = useCpvTokens();
  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="right"
      width={width}
      rootClassName="cu-drawer"
      rootStyle={vars}
      closeIcon={null}
      extra={<button type="button" className="cu-link" aria-label="Close" onClick={onClose} style={{ fontSize: "var(--cu-font-close)", lineHeight: 1, color: "var(--cu-muted)", fontWeight: 400 }}>×</button>}
      title={(
        <div data-testid={testId}>
          <h2 className="cu-drawer-title">{title}</h2>
          <div className="cu-drawer-chips">{chips}{status ? <span style={{ marginLeft: 'auto' }}>{status}</span> : null}</div>
        </div>
      )}
      footer={footer ? <div className="cu-drawer-footer">{footer}</div> : null}
      destroyOnHidden
    >
      {tabs ? <Tabs activeKey={activeTab} onChange={onTab} items={tabs} /> : children}
    </Drawer>
  );
}
